import store from '../store';
import router from '@/router';
import i18n from '@/i18n.js';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
};

const VALID_STATUSES = [200, 201, 202, 203, 204, 300, 301, 302, 303, 304];

export function getHeaders(multipart = false) {
  let defaultHeaders = DEFAULT_HEADERS;

  if (multipart && multipart == 'form-data') {
    // Actually, this step is unnecessary. Why? Read this doc:
    // https://developer.mozilla.org/en-US/docs/Web/API/FormData
    defaultHeaders = {
      ...defaultHeaders,
      'Content-Type': 'multipart/form-data'
    };
  }

  const token = localStorage.getItem('api_token');

  if (token) {
    defaultHeaders = {
      ...defaultHeaders,
      Authorization: `Bearer ${token}`
    };
  }

  return defaultHeaders;
}

export function checkResponse(response) {
  if (VALID_STATUSES.includes(response.status)) {
    return response;
  }

  if (response.status) {
    console.warn('ERROR RESPONSE STATUS');
    return Promise.reject(new Error('USER_ANONYMOUS'));
  }

  // let error = new Error(response.statusText)
  // return Promise.reject(error)
}

export function handleError(error) {
  let snackMessage = i18n.t('MESSAGE.SOMETHING_WENT_WRONG');

  if (error.response) {
    const { message } = error;
    const { status } = error.response;

    switch (status) {
      case 400:
        console.warn(message);
        break;

      case 401:
        console.warn(message);
        router.push({ name: 'logout' });
        break;

      case 403:
        console.warn(message);
        break;

      case 404:
        console.warn(message);
        break;

      case 500:
        console.warn(message);
        break;

      default:
        console.warn(message);
        break;
    }
  } else if (error.request) {
    snackMessage = i18n.t('MESSAGE.SERVER_IS_NOT_RESPONDING');
  } else {
    console.log('Error', error.message);
  }

  store.commit('snackbar/setSnack', { status: 'error', text: snackMessage });
}
